import { request, API_URL } from "./axiosInstance";
// ARCH-5: category reads come from the unauthenticated Store API.
import { fetchStoreCategories } from "./storeApi";
const CAT_CACHE_KEY = "categories_cache";
const CAT_CACHE_TIME_KEY = "categories_cache_time";
const CAT_TTL = 1000 * 60 * 60 * 6; // 6 hours


// Get all categories
{/**
export async function getAllCategories(page = 1, per_page = 10) {
    try {
        const response = await catalogRequest('GET', `${API_URL}/products/categories`, {}, { page, per_page });
        return {
            data: response.data,
            total: response.headers?.['x-wp-total'] || response.length,
            totalPages: parseInt(response.headers?.['x-wp-totalpages'] || 1),
        };
    } catch (error) {
        console.error('Error fetching categories:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        return { data: [], totalPages: 1 };
    }
}**/}
export async function getAllCategories(page = 1, per_page = 10) {

    // 1️ Try to load from LocalStorage cache
    const cached = localStorage.getItem(CAT_CACHE_KEY);
    const cachedTime = localStorage.getItem(CAT_CACHE_TIME_KEY);

    if (cached) {
        const parsed = JSON.parse(cached);
        const age = Date.now() - Number(cachedTime);

        console.log("Loaded categories from cache");

        //  If cache is old → refresh in background
        if (age > CAT_TTL) {
            console.log("Refreshing categories in background…");
            refreshCategories(page, per_page);
        }

        return {
            data: parsed,
            totalPages: 1
        };
    }

    // No cache  Fetch from WooCommerce
    try {
        // ARCH-5: unauthenticated Store API. wc/v3 required `manage_product_terms`
        // merely to LIST categories; reading them publicly needs no capability
        // at all.
        //
        // (An earlier version of this comment said that capability also permits
        // creating, editing and deleting categories. It does not — checked
        // against wc_rest_check_product_term_permissions, where create/edit map
        // to `edit_product_terms` and delete to `delete_product_terms`. The real
        // over-reach is `wc/v3/products/attributes`, which gates ALL SIX
        // operations on `manage_product_terms` alone. Either way the capability
        // is no longer needed here.)
        const response = await fetchStoreCategories({ page, per_page });

        // Save to cache
        localStorage.setItem(CAT_CACHE_KEY, JSON.stringify(response.data));
        localStorage.setItem(CAT_CACHE_TIME_KEY, Date.now().toString());

        return {
            data: response.data,
            total: response.headers?.['x-wp-total'] || response.data.length,
            totalPages: parseInt(response.headers?.['x-wp-totalpages'] || 1),
        };

    } catch (error) {
        console.error("Error fetching categories:", error);
        return { data: [], totalPages: 1 };
    }
}

//  Background refresh (non-blocking)
async function refreshCategories(page, per_page) {
    try {
        const response = await fetchStoreCategories({ page, per_page });

        localStorage.setItem(CAT_CACHE_KEY, JSON.stringify(response.data));
        localStorage.setItem(CAT_CACHE_TIME_KEY, Date.now().toString());

        console.log("Category cache refreshed");
    } catch (error) {
        console.warn("Category refresh failed");

    }}

    
// Create a new category
export async function createCategory(categoryData) {
    try {
        const data = { name: categoryData.name };

        // Use existing image ID directly
        if (categoryData.image_id) {
            data.image = { id: categoryData.image_id };
        }

        const response = await request('POST', `${API_URL}/products/categories`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating category:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to create category');
    }
}


// Update a category
export async function updateCategory(id, categoryData) {
    try {
        const data = {
            name: categoryData.name,
        };

        if (categoryData.image_id) {
            data.image = { id: categoryData.image_id };
        }

        const response = await request('PUT', `${API_URL}/products/categories/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating category:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to update category');
    }
}

// Delete a category
export async function deleteProductCategory(id) {
    try {
        return await request('DELETE', `${API_URL}/products/categories/${id}`, {}, { force: true });
    } catch (error) {
        console.error('Error deleting category:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to delete category');
    }
}